module.exports = __webpack_public_path__ + "img/armando_timmy-01.2025e5fe.png";